/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-compressions',['require','underscore','jquery','screens/scenario-mapper/scenario','activities/scenario-activity'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  //var Slider = require('activities/airway-slider');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityCompressions = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    speed: 0,
    correctHand: null,

    kneePos: 0,
    targetPosition: 600,
    positionTolerance: 70,
    ratioMod: 10,

    leftArrow: null,
    rightArrow: null,
    done: null,

    hands: null,
    knees: null,

    cpPosition: null,
    cpSlider: null,
    cpHandPanel: null,
    directionsPanel: null,

    cpHands: null,
    cpPanel: null,

    minPace: 600, // (100 / 60) interval between clicks (ms,
    maxPace: 500, // (120 / 60) interval between clicks (ms,
    correctCompressionCount: 30,
    maxCompressionCount: 40,
    compressionData: { },
    bounds: { left: 50, right: 713 },

    /*attempt: 0,
    maxAttempts: 2,
    scoreValue: 4,

    handPanel: null,
    slider: null,
    doneBtn: null,

    directionsPanel: null,
    tiltObject: null,*/

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      this.performance = 'good';

      this.attempt = 0;
      this.maxAttempts = 2;
      this.scoreValue = 4;

      //this.activityReady();
    },

    begin: function()
    {
      ScenarioActivity.prototype.begin.apply(this, arguments);
      //var self = this;
      //console.warn('show', this.get('#animation-sprite img'));

      //this.playAudio();
      this.playAudio('primary', this.content, this.loadCurrentPhase);
      /*//console.log(this.get('#animation-sprite'));
      this.get('#animation-sprite').sprite({
        'fps': 1,
        'no_of_frames': 2,
        'play_frames': 4,
        //'on_last_frame': self.finish.bind(self)
      });
      //console.log('showing now it should play');
      setTimeout(function() {self.get('#animation-sprite').spStart(true);}, 1000);*/
    },

    onBeforeDestroy: function()
    {
      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    setupBodyPositioning: function()
    {
      //console.log('Setting up BodyPositioning');

      this.playAudio('audio', this.currentPhase);

      this.cpPosition = this.currentScene.find('[data-mc=panelHolder]');
      this.cpSlider = this.currentScene.find('[data-mc=sliderHolder]');

      // activate slider
      this.leftArrow = this.cpSlider.find('[data-mc=left]');
      this.leftArrow.on('touchstart mousedown', $.proxy(this.onLeftClick, this));
      this.leftArrow.on('touchend mouseup', $.proxy(this.onMouseOff, this));
      this.leftArrow.on('mouseout', $.proxy(this.onMouseOff, this));

      this.rightArrow = this.cpSlider.find('[data-mc=right]');
      this.rightArrow.on('touchstart mousedown', $.proxy(this.onRightClick, this));
      this.rightArrow.on('touchend mouseup', $.proxy(this.onMouseOff, this));
      this.rightArrow.on('mouseout', $.proxy(this.onMouseOff, this));

      this.done = this.cpSlider.find('[data-mc=done]');
      this.done.on('click', $.proxy(this.onDoneClick, this));

      // randomize knee location
      var $randX = _.random(this.positionTolerance * 2, this.positionTolerance * 4);
      if (_.random(1) === 1)
        $randX = -$randX;

      if (this.currentScene.find('[data-mc=correct]').length > 0)
        this.targetPosition = this.currentScene.find('[data-mc=correct]').position().left;

      this.kneesHolder = this.currentScene.find('[data-mc=kneesHolder]');

      //var $dif = this.kneesHolder.position().left - this.targetPosition + $randX;
      this.kneePos = this.targetPosition + $randX;
      this.kneesHolder.css('left', this.kneePos);// = this.kneePos = this.targetPosition + $randX;

      this.updateInsetPos();
      //this.cpPosition.find('[data-mc=user]').css('left', (this.targetPosition + $randX) / this.ratioMod);
    },

    onLeftClick: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.speed = -5;
      this.slideInt = setInterval($.proxy(this.slideBody, this), 30);
      return false;
    },

    onRightClick: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.speed = 5;
      this.slideInt = setInterval($.proxy(this.slideBody, this), 30);
      return false;
    },

    onMouseOff: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.speed = 0;
      clearInterval(this.slideInt);
      return false;
    },

    slideBody: function($e)
    {
      //console.log('slide', this.kneesHolder.width());
      if (this.kneesHolder.position().left + this.speed < this.bounds.left || this.kneesHolder.position().left + this.speed > this.bounds.right - (this.kneesHolder.width()))
        return;

      this.kneesHolder.css('left', '+=' + this.speed);
      this.updateInsetPos();
      //this.cpPosition.find('[data-mc=user]').css('left', '+=' + (this.speed / this.ratioMod));
    },

    updateInsetPos: function()
    {

      this.cpPosition.find('[data-mc=user]').css('left', this.kneesHolder.position().left / this.ratioMod);
    },

    setupHandPositioning: function()
    {
      this.playAudio('audio', this.currentPhase);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });
      this.setHeadTilt();

      Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');
      this.kneesHolder = this.currentScene.find('[data-mc=kneesHolder]');

      if (this.kneePos !== 0)
        this.kneesHolder.css('left', this.kneePos);

      /*var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');

      _.each(this.dropPanel.find('.activity-drop'), function(dropDiv) {
        var $dropItem = $(dropDiv);
        var $validAccept = (self.currentPhase['universal']) ? '.activity-drag' : '[data-mc=' + $dropItem.attr('data-mc').replace('drop', 'item') + ']';

        $dropItem.droppable({
          accept: $validAccept,
          hoverClass: 'over',
          greedy: true,
          drop: $.proxy(self.onCorrectDrop, self, $dropItem)
        });
      });*/

      //this.handPanel.setup( { onDragStop: this.onCorrectDrop } );
    },

    onEndDrag: function(self)
    {
      var $drag = $(this.target);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drag') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');
      //console.log('end', $drag, $cDrop);

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && Draggable.hitTest($drag, $cDrop, '55%')) // correct
      {
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    revertDrag: function(drag)
    {
      //TweenLite.to(drag, 0.5, {transform: 'translate3d(' + drag.data().origin.left + ', ' + drag.data().origin.top + ', 0)'});
      TweenLite.to(drag, 0.5, {left: drag.data().origin.left, top: drag.data().origin.top});
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      //console.log('correct drpo');
      ////console.log('on up ', $dropItem, $e, $drag.draggable);
      //var $correct = false;
      //var $drop;
      //var $point;
      //var $coords;
      //var $dragPoint;
      //var $dragCoords;

      // $drag.draggable.draggable('disable');
      Draggable.get($drag).disable();

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], this.loadCurrentPhase);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    onIncorrectDrop: function($scope, $drag)
    {
      $scope.scoreValue--;
      $scope.attempt++;
      if ($scope.attempt >= $scope.maxAttempts)
      {

        $scope.phaseIndex++;
        $scope.moveHandsToCorrectSpots($drag);
        $scope.playAudio('audio-feedback-incorrect-final', $scope.phases[$scope.phaseIndex - 1], $scope.loadCurrentPhase);
        return;
        //return false;
      }
      else
      {
        $scope.revertDrag($drag);
        //$drag.returnToOrigin({time: 0.25, transition: 'easeoutquad'});
      }
      $scope.playAudio('audio-feedback-incorrect', $scope.currentPhase);
      return true;
    },

    moveHandsToCorrectSpots: function($activeDrag)
    {
      //this.handPanel.find('.airway-hand').draggable('disable');
      var $sendBack = true;

      for (var $key = 0; $key < this.handPanel.find('.airway-hand').length; $key++)
      {
        var $drag = $(this.handPanel.find('.airway-hand')[$key]);
        Draggable.get($drag).disable();
        var $id = $drag.attr('data-mc').replace('item', 'drop');//NLUtils.getItemNumber($drag.mc);
        var $drop = this.get('[data-mc=drop_items]').find('[data-mc=' + $id + ']');

        if ($drop.length > 0)
        {
          if ($drag.attr('data-mc') === $activeDrag.attr('data-mc'))
            $sendBack = false;

          var $left = $drop.offset().left - this.handPanel.offset().left;
          var $top = $drop.offset().top - this.handPanel.offset().top;

          if (this.get('.correctDragHolder').length > 0)
            this.get('.correctDragHolder').append($drag);

          $drag.animate({left: $left, top: $top}, {duration: 250});
        }
        else
        {
          this.revertDrag($drag);
        }
      }

      return $sendBack;
    },

    setHeadTilt: function()
    {
      var $rotation = Scenario.getVariableValueByName('openAirway_rotation');
      //trace('rotation: ' + $rotation);
      //console.warn('setHeadTilt', $rotation);
      //console.warn(Scenario.getVariableValueByName('openAirway_rotation'));
      var $head = this.get('[data-mc=body] [data-mc=head]');
      if ($head && $rotation)
        $head.rotate(parseInt($rotation));
    },

    allComplete: function()
    {
      return true;
    },

    onDoneClick: function($e)
    {
      // check correctness
      this.phaseAttempts++;
      var $result = this.evaluateBodyPosition();
      var $kneeDelta;

      // check correctness
      if ($result.correct)
      {
        this.phaseIndex++;

        this.leftArrow.addClass('disabled');
        this.leftArrow.off('mousedown mouseout mouseup touchstart touchend');
        this.rightArrow.addClass('disabled');
        this.rightArrow.off('mousedown mouseout mouseup touchstart touchend');
        this.done.addClass('disabled');
        this.done.off('click');

        this.kneePos = this.kneesHolder.position().left;

        // play correct feedback
        this.kneePos = this.targetPosition;
        this.kneesHolder.animate({left: this.targetPosition}, {duration: 500, complete: $.proxy(this.kneesInPos, this, 'audio-feedback-correct', this.phases[this.phaseIndex - 1])});
        //Tweener.addTween(this.kneesHolder, { x: this.targetPosition, time:0.5, onComplete: kneesInPos, onCompleteParams:['audio-feedback-correct', _phases[this.phaseIndex - 1]]});
        //this.kneesHolder.x = this.targetPosition;
        //this.playAudio('audio-feedback-correct', _phases[this.phaseIndex-1], this.loadCurrentPhase);
      }
      else if (this.phaseAttempts >= 2)
      {
        this.phaseIndex++;

        this.leftArrow.addClass('disabled');
        this.leftArrow.off('mousedown mouseout mouseup touchstart touchend');
        this.rightArrow.addClass('disabled');
        this.rightArrow.off('mousedown mouseout mouseup touchstart touchend');
        this.done.addClass('disabled');
        this.done.off('click');

        this.kneePos = this.targetPosition;
        $kneeDelta = this.targetPosition - this.kneesHolder.position().left;
        //this.kneesHolder.x = this.kneePos = this.targetPosition;
        this.cpPosition.find('[data-mc=user]').css('left', '+=' + ($kneeDelta / this.ratioMod));

        // play incorrect feedback
        this.kneesHolder.animate({left: this.targetPosition}, {duration: 500, complete: $.proxy(this.kneesInPos, this, 'audio-feedback-incorrect-final', this.phases[this.phaseIndex - 1])});
        //Tweener.addTween(this.kneesHolder, { x:this.targetPosition, time:0.5, onComplete: kneesInPos, onCompleteParams:['audio-feedback-incorrect-final', _phases[this.phaseIndex-1]] } );
        //this.playAudio('audio-feedback-incorrect-final', _phases[this.phaseIndex-1], this.loadCurrentPhase);
      }
      else
      {
        this.downgradePerformance();

        var $audio = _.findWhere(this.currentPhase.ContentAudio, {id: $result.audio});

        if (!$audio)
          $result.audio = 'audio-feedback-incorrect';

        // play incorrect feedback
        this.playAudio($result.audio, this.currentPhase);
      }
    },

    kneesInPos: function($feedbackStr, $phase)
    {
      this.playAudio($feedbackStr, $phase, $.proxy(this.loadCurrentPhase, this));
    },

    evaluateBodyPosition: function()
    {
      var $result = { };
      $result.correct = true;

      var $min = this.targetPosition - this.positionTolerance;
      var $max = this.targetPosition + this.positionTolerance;

      if (this.kneesHolder.position().left < $min)
      {
        $result.correct = false;
        $result.audio = 'audio-feedback-incorrect-low';
        //console.log('not enough');
      }
      else if (this.kneesHolder.position().left > $max)
      {
        $result.correct = false;
        $result.audio = 'audio-feedback-incorrect-high';
        //console.log('too much');
      }

      return $result;
    },

    setupCompressions: function()
    {
      //console.log('Setting up Compressions');

      this.compressionData.clicks = [];
      this.compressionData.startTime = 0;

      this.playAudio('audio', this.currentPhase);

      this.kneesHolder = this.currentScene.find('[data-mc=kneesHolder]');

      if (this.kneePos !== 0)
        this.kneesHolder.css('left', this.kneePos);

      // get correct compressions count
      var $compObj = _.findWhere(this.currentPhase.ContentObject, {id: 'compressions'});
      if ($compObj)
        this.correctCompressionCount = $compObj.value;

      this.feedbackHolder = this.currentScene.find('[data-mc=feedbackHolder]');
      this.feedbackHolder.hide();//.visible = false;

      // get some hands
      this.cpHands = this.currentScene.find('[data-mc=handsHolder] [data-mc=hands]');
      //this.cpHands.gotoAndStop(1);
      this.setHeadTilt();

      // activate compressions
      //_hands = new Button(this.cpHands.hotspot);
      //_hands.setup( { onMouseDown: this.onCompress, onMouseUp: this.onDecompress } );
      this.cpHands.on('touchstart mousedown', $.proxy(this.onCompress, this));
      this.cpHands.on('touchend mouseup', $.proxy(this.onDecompress, this));

      // add the info panel
      this.cpPanel = this.currentScene.find('[data-mc=counterHolder]');//.panel;
      this.cpPanel.find('[data-mc=message]').attr('data-pace', 'good');
      //this.cpPanel.info.message.gotoAndStop('good');

      this.done = this.cpPanel.find('[data-mc=done]');
      //this.done.one('click', $.proxy(this.onCompressDoneClick, this));
      this.done.addClass('disabled');

      // _done = new Button(this.cpPanel.done);
      // _done.setup( { onMouseClick: this.onCompressDoneClick } );

      // _done.disable();
      //console.log('comp', this.currentPhase);
      this.infoPanel = this.cpPanel.find('[data-mc=info]');
      if (this.currentPhase['hideCounter'] === 'true')
        this.infoPanel.find('[data-mc=text_tf]').hide();//.visible = !this.currentPhase['hideCounter']; // if counter is hidden
      else
        this.infoPanel.find('[data-mc=disabled_mc]').hide();//.visible = this.currentPhase['hideCounter']; // if counter is hidden

      if (this.currentPhase['hidePace'] === 'true')
        this.infoPanel.find('[data-mc=message]').hide();//.visible = !this.currentPhase['hidePace']; // if pace helper is hidden

      //this.cpHands.addEventListener(Event.ENTER_FRAME, this.onEnterFrame);
    },

    onCompress: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      var $date = _.now();
      this.compressionData.clicks.push($date);
      this.cpHands.on('mouseout', $.proxy(this.onDecompress, this));

      if (this.cpHands)
        this.cpHands.addClass('compress').removeClass('decompress');

      if (this.currentPhase['interrupt'] && this.compressionData.clicks.length >= this.currentPhase['interrupt']) // interrupt
      {
        this.finish(this.performance);
        return false;
      }

      if (this.done.hasClass('disabled'))
      {
        this.done.one('click', $.proxy(this.onCompressDoneClick, this));
        this.done.removeClass('disabled');
      }

      this.infoPanel.find('[data-mc=text_tf]').html(this.compressionData.clicks.length);

      var $pace = this.getPace();
      var $pacePerMin = Math.round(60000 / $pace);
      var $result = this.evaluatePace($pacePerMin);

      if (this.compressionData.clicks.length > 3)
      {
        this.infoPanel.find('[data-mc=message]').attr('data-pace', $result);
      }

      return false;
    },

    onDecompress: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.cpHands.off('mouseout');

      if (this.cpHands)
        this.cpHands.addClass('decompress').removeClass('compress');//gotoAndPlay(6);

      if (this.compressionData.clicks.length >= this.maxCompressionCount)
      {
        this.performance = ScenarioActivity.PERFORMANCE_POOR;
        this.compressionsDone();
      }
      return false;
    },

    onCompressDoneClick: function($e)
    {
      this.compressionsDone();
    },

    compressionsDone: function()
    {
      this.done.off('click');
      this.done.addClass('disabled');

      if (this.currentPhase['interrupt']) // interrupt
      {
        this.finish();
        return;
      }

      this.cpHands.off('touchstart mousedown');
      this.cpHands.off('touchend mouseup');
      this.cpHands.addClass('disabled');
      this.cpPanel.hide();
      //_cpPanel.visible = false;

      var $pace = Math.max(this.getPace(this.correctCompressionCount), 100);
      var $pacePerMin = Math.round(60000 / $pace);
      var $result = this.evaluatePace($pacePerMin);

      this.infoPanel.find('[data-mc=message]').attr('data-pace', $result);

      var $correct = (this.compressionData.clicks.length === Number(this.correctCompressionCount)) && ($result === 'good');

      //console.log('correct: ' + $correct);

      // show feedback
      var $panel = this.feedbackHolder;
      $panel.find('[data-mc=count]').html(this.compressionData.clicks.length.toString());
      $panel.find('[data-mc=pace]').html($pacePerMin.toString());

      this.feedbackHolder.show();

      this.done = $panel.find('[data-mc=done]');
      this.done.hide();

      //_done = new Button($panel.done);
      //_done.setup( { onMouseClick: this.onFinalDoneClick } );

      // check correctness
      if ($correct)
      {
        // play correct feedback
        this.playAudio('audio-feedback-correct', this.currentPhase, this.onCompleteHandler, this.killSomeTime);
      }
      else
      {
        this.downgradePerformance();

        // play incorrect feedback
        this.playAudio('audio-feedback-incorrect', this.currentPhase, this.onCompleteHandler, this.killSomeTime);
      }

      this.phaseIndex++;
    },

    killSomeTime: function()
    {
      //var $timer:Timer = new Timer(3000);
      //$timer.addEventListener(TimerEvent.TIMER, this.onKilledTime);
      //$timer.start();
      setTimeout($.proxy(this.onKilledTime, this), 2000);
    },

    onKilledTime: function($e)
    {
      //$e.target.removeEventListener(TimerEvent.TIMER, this.onKilledTime);

      this.finish();
    },

    onCompleteHandler: function($e)
    {
      this.finish();
    },

    evaluatePace: function($pace)
    {
      //console.log('PACE: ' + $pace);
      if ($pace < 100)
        return 'slow';
      else if ($pace > 120)
        return 'fast';

      return 'good';
    },

    getPace: function($num)
    {
      $num = $num === undefined ? 5 : $num;

      if (this.compressionData.clicks.length < 2)
        return 0;

      $num = Math.min($num, this.compressionData.clicks.length - 1);

      // find number of seconds between the last click and the click we are evaluating
      var $lastClick = this.compressionData.clicks[this.compressionData.clicks.length - 1];
      var $firstClick = this.compressionData.clicks[this.compressionData.clicks.length - ($num + 1)];

      var $timeElapsed = $lastClick - $firstClick;

      // divide by the num clicks we are evaluating to get the average pace per click
      return $timeElapsed / $num;
    },

    onFinalDoneClick: function($e)
    {
      this.finish();
    }

  /*****************************************************************************************************************///}

  });

  return ActivityCompressions;

});

